"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@chakra-ui/react");
var _reactDnd = require("react-dnd");
var _TableRow = require("../FileList/TableRow");
var _jsxRuntime = require("react/jsx-runtime");
const DnDBcrmbItem = props => {
  const [, drop] = (0, _reactDnd.useDrop)({
    accept: _TableRow.DND_FILE_LIST_ITEM_TYPE,
    drop(item, monitor) {
      props.onDnd(item.index, props.index);
    }
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.BreadcrumbLink, {
    ref: drop,
    onClick: () => props.onClick(props.index),
    children: props.children
  });
};
var _default = DnDBcrmbItem;
exports.default = _default;